import { Timestamp } from ".";

export interface IProduct {
  id: string;
  workspaceId: string;
  descriptionShort: string;
  description: string;
  imgUrls?: string[];
  productType: string[];
  pricing?: IProductPricing;
  seatsEnabled?: boolean;
  seatCount?: number;
  weight: number;
  length: number;
  height: number;
  width: number;
  productId?: string;
  createdAt?: Timestamp;
  isPublic?: boolean;
}

export enum IPriceModel {
  SEAT = "Seat",
  FIXED = "Fixed",
  VOLUME = "Volume",
  WEIGHT = "Weight",
  DISTANCE = "Distance",
  TIME = "Time",
}

export interface IProductPricing {
  priceModel: IPriceModel[];
  pricePerSeat?: number;
  pricePerCargoUnit?: number;
  pricePerDistanceUnit?: number;
  pricePerVolumeUnit?: number;
  pricePerWeightUnit?: number;
  pricePerTimeUnit?: number;
  timePeriodInMinutes?: number;
  vat?: number;
  pricesIncludeVat?: boolean;
}

export interface IProductDeliveryInformationValidated {
  deliveryInformation?: boolean;
  quantity?: boolean;
}

export interface IProductPropertyValidated {
  descriptionShort?: boolean;
  description?: boolean;
  weight?: boolean;
  length?: boolean;
  height?: boolean;
  width?: boolean;
  price?: boolean;
}
